import * as jwtDecode from 'jwt-decode';

import SettingProviderStorage from '@produtos/store-setting-provider/src/storage';

export default async function getPath(instance, serviceName, endpoint) {
  const storage = new SettingProviderStorage();

  const token = await storage.getCookieToken();
  const pin = await storage.getCookiePIN();
  const dataToken = token?.id ? jwtDecode.jwtDecode(token.id) : null;

  let prePath;
  if ((!process.env.VUE_APP_SYNC_DEV_PROVIDER_PATH && dataToken) || serviceName !== 'Sync') {
    prePath = `${pin.protocol ?? 'http'}://${pin.host}${pin.port ? `:${pin.port}` : ''}`;
    const subPath = dataToken?.aud?.find((c) => c.substr(1, c.length - 1) === serviceName);
    if (subPath) prePath += subPath;
  } else if (!process.env.VUE_APP_SYNC_DEV_PROVIDER_PATH) {
    prePath = `${pin.protocol ?? 'http'}://${pin.host}${pin.port ? `:${pin.port}` : ''}/Version`;
  } else {
    prePath = process.env.VUE_APP_SYNC_DEV_PROVIDER_PATH;
  }

  if (endpoint) {
    prePath += `/${endpoint}`;
  }

  return prePath;
}

export async function getPathAxiosInstance(instance, serviceName, endpoint) {
  const storage = new SettingProviderStorage();

  const token = instance.token ?? (await storage.getCookieToken())?.id;
  const pin = instance.pin ?? await storage.getCookiePIN();
  const dataToken = token ? jwtDecode.jwtDecode(token) : null;

  let prePath;
  if (serviceName !== 'Sync') {
    prePath = `${pin.protocol ?? 'http'}://${pin.host}${pin.port ? `:${pin.port}` : ''}`;
    const subPath = dataToken?.aud?.find((c) => c.substr(1, c.length - 1) === serviceName);
    prePath += subPath ?? (serviceName?.startsWith('Sync') ? `/${serviceName}` : '');
  } else if (!process.env.VUE_APP_SYNC_DEV_PROVIDER_PATH) {
    prePath = `${pin.protocol ?? 'http'}://${pin.host}${pin.port ? `:${pin.port}` : ''}/Sync`;
  } else {
    prePath = process.env.VUE_APP_SYNC_DEV_PROVIDER_PATH;
  }

  if (endpoint) {
    prePath += `/${endpoint}`;
  }

  return prePath;
}
